import { Box, Typography } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { IFieldDiff } from "../../../../../types/review";

interface FieldDiffProps<T> {
  diff: IFieldDiff<T>;
  formatValue?: (value: T) => string | number;
}

const FieldDiff = <T,>({
  diff,
  formatValue = (value) => String(value),
}: FieldDiffProps<T>) => {
  return (
    <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
      <Typography
        component="span"
        sx={{
          color: "error.main",
          textDecoration: "line-through",
          fontWeight: 500,
        }}
      >
        {formatValue(diff.old)}
      </Typography>
      <ArrowForward sx={{ fontSize: 16, color: "text.secondary" }} />
      <Typography
        component="span"
        sx={{
          color: "success.main",
          fontWeight: 600,
        }}
      >
        {formatValue(diff.new)}
      </Typography>
    </Box>
  );
};

export default FieldDiff;

